// extracted by mini-css-extract-plugin
export default {"iconLeft":"system_button-module__iconLeft--2OhIk","iconRight":"system_button-module__iconRight--ajqK1"};